export default __webpack_public_path__ + "static/media/kitchen3-afterK.2c31d060.jpg";